/** 페이지 배너 합치기 — 의존성 없는 순수 함수(tests/pageBanners.test.ts) */

export interface PageBanner {
    id: number;
    title?: string;
    imageUrl?: string | null;
    mobileImageUrl?: string | null;
    linkUrl?: string | null;
    displayOrder: number;
}

/**
 * 한 자리(상단·하단)의 배너 — 페이지 위치 배너 + "모든 페이지" 배너를 합쳐 같은 배너는 한 번만, 우선순위(displayOrder) → id 순.
 * 이미지가 없는 배너(텍스트 배너)는 목록 배너와 같이 건너뛴다.
 */
export function mergeSlot(byLocation: Record<string, PageBanner[] | undefined> | null | undefined, locations: string[]): PageBanner[] {
    if (!byLocation) return [];
    const seen = new Set<number>();
    const merged: PageBanner[] = [];
    for (const location of locations) {
        for (const banner of byLocation[location] ?? []) {
            if (!banner?.imageUrl || seen.has(banner.id)) continue;
            seen.add(banner.id);
            merged.push(banner);
        }
    }
    return merged.sort((a, b) => (a.displayOrder - b.displayOrder) || (a.id - b.id));
}
